// 与后端 App\Enums\OssObjectTypes 保持一致
export const courseMediaTypes = {
  trailer: {
    value: 21,
    name: '预告视频',
  },
  classroom: {
    value: 22,
    name: '课堂视频',
  },
};